import React from "react";
import SorensenXgMetadata from "./vendors/SorensenXgMetadata";
import PeakComARU2856CMetadata from "./vendors/PeakComARU2856CMetadata";

export default function DeviceMetadata({vendor, metadata, onChange, onValidationSuccess, onValidationError}) {
    switch (vendor) {
        case "SORENSEN_XG": {
            return <SorensenXgMetadata metadata={metadata}
                                       onChange={onChange}
                                       onValidationSuccess={onValidationSuccess}
                                       onValidationError={onValidationError}/>
        }

        case "PEAK_COM_ARU2856C": {
            return <PeakComARU2856CMetadata metadata={metadata}
                                            onChange={onChange}
                                            onValidationSuccess={onValidationSuccess}
                                            onValidationError={onValidationError}/>
        }

        default:
            return null;
    }
}